
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

type InvalidInvitationProps = { message?: string };

export const InvalidInvitation = ({ message }: InvalidInvitationProps) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h1 className="text-center text-3xl font-bold text-primary-700 mb-2">
          Doyence Estimating
        </h1>
        <h2 className="text-center text-xl font-semibold text-gray-900">
          Invalid Invitation
        </h2>
        <p className="text-center mt-4 text-gray-600">
          {message ?? "This invitation link is invalid or has expired."}
        </p>
        <div className="mt-6 flex justify-center">
          <Button onClick={() => navigate("/")} variant="outline">
            Return to Home
          </Button>
        </div>
      </div>
    </div>
  );
};
